import Main from '@/views/main.vue'

import {MenuRouter} from './service'

const serviceMenuRouter = {
  has: 'service',
  path: '/',
  icon: 'android-people',
  name: 'serviceMenuRouter',
  title: '服务项目',
  component: Main,
  children: [
    ...MenuRouter
  ]
}

const serviceOtherRouter = {
  path: '/',
  icon: 'android-people',
  name: 'serviceOtherRouter',
  title: '维修项目',
  component: Main,
  children: [
  ]
}

export {serviceMenuRouter, serviceOtherRouter}



// WEBPACK FOOTER //
// ./src/router/service/index.js